var longFormPages = (function () {
  var element = document.getElementById("long-form-sidebar-container");
  var getOffset = element.offsetTop;
  var doc_sidebar = document.getElementById("long-form-sidebar-container");
  var scrollAlong = {
    getOffset: function () {
      return getOffset;
    },
    /** Get Document height in Js
     * https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript/44077777
     */
    getDocumentHeight: function () {
      var body = document.body,
        html = document.documentElement;

      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      return height;
    },
  };
  function init() {
    uiBindings();
  }

  function setOffset(offset) {
    getOffset = offset;
  }

  var uiBindings = function () {
    window.addEventListener("load", getSidebar);
    window.addEventListener("scroll", getSidebar);

    function getSidebar() {
      if (
        window.pageYOffset >
        scrollAlong.getDocumentHeight() -
          (document.getElementById("footer-habitat").offsetHeight +
            document.querySelector(".long-form-cta").offsetHeight) -
          84 -
          doc_sidebar.scrollHeight
      ) {
        doc_sidebar.classList.remove("bs-no-stick");
        doc_sidebar.classList.add("bs-stick-bottom");
      } else {
        // If window scroll is not on the footer
        if (doc_sidebar.classList.contains("bs-stick-bottom")) {
          doc_sidebar.classList.remove("bs-stick-bottom");
          if (!doc_sidebar.classList.contains("bs-stick-top")) {
            doc_sidebar.classList.add("bs-no-stick");
          }
        }
      }
      var element = document.querySelector(".long-form-template");
      if (window.pageYOffset > element.offsetTop - 7) {
        if (!doc_sidebar.classList.contains("bs-stick-top")) {
          // Avoid flickering by adding sticky class only once.
          doc_sidebar.classList.remove("bs-no-stick");
          doc_sidebar.classList.add("bs-stick-top");
        }
      } else {
        doc_sidebar.classList.remove("bs-stick-top");
        doc_sidebar.classList.add("bs-no-stick");
      }
    }
    return scrollAlong;
  };
  return {
    init: init,
    setOffset: setOffset,
  };
})();

var longFormHeadings = document.querySelectorAll(
  ".long-form-template section > h2"
);
for (var i = 0; i < longFormHeadings.length; i++) {
  var headingText = longFormHeadings[i].textContent;
  var headingTrigger = longFormHeadings[i].getAttribute("data-trigger");
  var parentElement = longFormHeadings[i].parentElement;
  var subHeading = parentElement.querySelectorAll("h3");

  var headingItems =
    '<li data-link="#' +
    headingTrigger +
    '" class=""><a href="#' +
    headingTrigger +
    '">' +
    headingText +
    "</a>";

  if (subHeading.length > 0) {
    headingItems += "<ul>";
  }

  for (var j = 0; j < subHeading.length; j++) {
    var subHeadingText = subHeading[j].textContent;
    var subHeadingTrigger = subHeading[j].getAttribute("data-trigger");
    headingItems +=
      '<li data-link="#' +
      subHeadingTrigger +
      '" class=""><a href="#' +
      subHeadingTrigger +
      '">' +
      subHeadingText +
      "</a></li>";
  }

  if (subHeading.length > 0) {
    headingItems += "</ul>";
  }

  headingItems += "</li>";

  document.getElementById("side-nav").innerHTML += headingItems;
}

/**
 * document load working is js
 * https://stackoverflow.com/questions/9899372/pure-javascript-equivalent-of-jquerys-ready-how-to-call-a-function-when-t
 */
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 1300) {
    var sidebarContainer = document.getElementById(
      "long-form-sidebar-container"
    );
    if (sidebarContainer) {
      longFormPages.init();
      /**
       * https://www.cssscript.com/easy-one-page-scroll-navigation-library-slide-nav/
       */
      window.slide = new SlideNav({
        activeClass: "active",
        speed: 75,
        changeHash: true,
      });
    }

    if (sidebarContainer) {
      longFormPages.setOffset(430);
    }

    window.addEventListener("resize", function () {
      if (sidebarContainer) {
        longFormPages.setOffset(430);
      }
    });
  }
});

//Init prettyPrint
window.addEventListener(
  "load",
  function (event) {
    PR.prettyPrint();
  },
  false
);

/**
 * Long Form Mobile Toggle
 */

/**
 * https://gomakethings.com/listening-for-click-events-with-vanilla-javascript/
 * Js Detect click
 */
if (document.body.classList.contains("page-template-long-form-doc")) {
  document.addEventListener(
    "click",
    function (event) {
      // If the clicked element doesn't have the right selector, bail
      if (!event.target.hasAttribute("data-trigger")) return;
      // Escape Mobile Menu.
      if (event.target.classList.contains("dropdown-toggle-mobile")) return;
      // Don't follow the link
      event.preventDefault();

      var clientViewportW = window.innerWidth;
      if (clientViewportW < 1300) {
        var element = event.target;
        if (element) {
          var trigger = element.getAttribute("data-trigger");
          var target = document.querySelector("[data-target=" + trigger + "]");
          target.classList.toggle("hide");
          element.classList.toggle("active");
        }
      }
    },
    false
  );
}
 